import React from "react";
import { useSelector } from "react-redux";
import { useCartransferQuery } from "../../../hooks/useCartransferQuery";
import { Row, Col } from "antd";
import CloseDocuments from "./CloseDocuments";

const CloseStep = () => {
  const cartransfer = useSelector((state) => state.cartransfer);
  useCartransferQuery(cartransfer?.id);
  
  // Removido el useEffect que causaba el loop infinito
  // Los datos ya están sincronizados a través de Redux

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <CloseDocuments cartransfer={cartransfer} />
      </Col>
    </Row>
  );
};

export default CloseStep;
